module.exports = __webpack_public_path__ + "img/32.19184521.jpg";